import {
  getCurrentAppLocale,
  parseRouteLangQuery,
  withAppLocaleQuery,
} from '~/composables/useAppLocale';

/** 모든 페이지 이동 시 ?lang= 유지 — Vue·레거시·새로고침 간 언어 일관성 */
export default defineNuxtRouteMiddleware((to, from) => {
  if (parseRouteLangQuery(to.query.lang)) {
    return;
  }

  const fromLang = parseRouteLangQuery(from.query?.lang);
  const lang = fromLang ?? getCurrentAppLocale();

  return navigateTo(
    {
      path: to.path,
      query: withAppLocaleQuery({ ...to.query }, lang),
      hash: to.hash,
    },
    { replace: true },
  );
});
